<template>
    <dynamic-form-container :scopes="scopes" :should-notify="true"/>
</template>

<script>
    import DynamicFormContainer from "../../organisms/forms/DynamicFormContainer";
    import formAlertMixin from "../../mixins/formAlertMixin";
    import profileSectionMixin from "../../mixins/profileSectionMixin";

    export default {
        name: "ProfileWorkplace",
        components: {DynamicFormContainer},
        mounted(){
            trackEvent("ProfileViewWorkplace", {})
            this.getSection('workplace');
        },
        mixins: [formAlertMixin, profileSectionMixin]
    }
</script>
